import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const newsfeedWidgetSizes: WidgetSizeT[] = [
  { w: 2, h: 2 },
  { w: 2, h: 3 },
  { w: 2, h: 4 },
];
